import { Component, h, Host, Prop, State } from '@stencil/core';
import { translate } from '~service/translation-service';

@Component({
  tag: 'mama-share',
  styleUrl: './mama-share.scss',
})
export class MamaShare {
  @Prop() label: string = 'share.this.job';
  @State() url: string;

  componentWillLoad() {
    this.url = window.location.href;
  }

  render() {
    return (
      <Host class="container">
        <span>{translate(this.label)}</span>
        <a title="Teilen bei WhatsApp" class="whatsapp" href={`https://api.whatsapp.com/send?text=${this.url}`} target="_blank" rel="noopener">
          <svg>
            <use xlinkHref="#whatsapp" />
          </svg>
        </a>
        <a title="Teilen bei Facebook" class="facebook" href={`https://www.facebook.com/sharer/sharer.php?u=${this.url}`} target="_blank" rel="noopener">
          <svg>
            <use xlinkHref="#facebook" />
          </svg>
        </a>
        <a title="Teilen via E-Mail" class="email" href={`mailto:?body=${this.url}`} target="_blank" rel="noopener">
          <svg>
            <use xlinkHref="#envelope" />
          </svg>
        </a>
      </Host>
    );
  }
}
